/* ==========================================================================================
   BRV · Bhavya Ramesh homepage — "BR Stores" film (5 Oct 2026, new film "Store Video - Website Landing")
   ------------------------------------------------------------------------------------------
   What it does
     The film plays by itself, silent, with no button and no tap, as soon as a quarter of the
     section is on screen — the first time from the very beginning — and plays the WHOLE film
     (the exported files are 1.5 x faster: 26.4 s instead of 40.2 s), then loops: the last aerial
     shot dissolves into the first close-up in the file itself, so the loop has no jump. It pauses when the section leaves the screen and carries on where it
     was when the section comes back; it also pauses in a hidden browser tab. Same on phone and
     computer. The film's first frame (the poster) is shown until the film is really playing,
     so there is never a black box and never a play symbol.
     If the phone refuses to start a film by itself (iPhone in Low Power Mode does), the poster
     stays, with no button, and the script tries again on the next scroll or tap anywhere.
     Visitors who switched on "reduce motion" on their phone or computer see the poster; a tap on it starts the film.
     During the film's own last card (the serpent and "Forbes Street, Kalaghoda"), on a phone the
     words over the film step aside for those 7 seconds, because that line would sit right under the
     button; they come back as soon as it has gone. On a computer the picture shifts down for the end
     card (while the screen is black) so the address line shows, then shifts back as the film fades in.
   Which file it plays
     Phones (a section narrower than 3:4) get the "phone" copy: a 3:4 frame that follows the people
     shot by shot (not a fixed middle crop), 1.35 MB. Computers get the full frame, 2.1 MB. Everything else gets the full
     frame. MP4 (H.264) where the browser plays it, otherwise WebM (VP9).
     The film is only fetched when the visitor is about a screen and a half away from it.
   Where the section comes from (first one found wins)
     1. <section class="brv" data-film-mp4 … > printed by sections/brv-stores.liquid — the live route.
     2. window.BRV = { mp4, webm, phoneMp4, phoneWebm, poster, after:'css selector', title, eyebrow, cta, href, stores:[{short}] }
        (used by the previews): the section is built after that element (or after the gift card / The craft).
   Safety
     Does nothing when there is no film. Never throws. Running it again replaces the previous copy.
   ========================================================================================== */
(function () {
  'use strict';
  /* ---- settings: one number each ---- */
  var START_AT = 0.25;      /* share of the section that must be on screen before the film starts (0.25 = 25 %) */
  var EXTRA_SPEED = 1;      /* the files are already 1.5 x; 1.1 here would play them 10 % faster still. 1 = as exported */
  var PHONE_RATIO = 0.75;   /* a section narrower than this (width / height) gets the phone copy of the film */
  var FETCH_AHEAD = 1.5;    /* start fetching the film when the section is this many screen-heights below */
  var END_CARD_AT = 0;      /* 0 = off: this film has no end card (it ends on the Gateway and "Experience the world of BR.").
                               For a film that ends on a card with a line low in the frame: the seconds where that card */
  var END_CARD_TO = 0;      /* starts and ends. On phones the words step aside then; on computers the picture shifts down. */

  var d = document, w = window;
  function q(s, r) { return (r || d).querySelector(s); }
  function el(tag, cls, html) { var e = d.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var COPY = { eyebrow: 'BR Stores', title: 'Come and try things on', cta: 'Our stores', href: '/pages/retail-store',
               alt: 'Film: inside the Bhavya Ramesh stores', cities: ['Kala Ghoda', 'Bandra', 'Khan Market'] };

  /* ---------- markup builder (previews, or a page without the Liquid section) ---------- */
  function build(cfg) {
    if (!cfg.mp4 && !cfg.webm && !cfg.src) return null;
    var c = {}; for (var k in COPY) c[k] = (cfg[k] != null && cfg[k] !== '') ? cfg[k] : COPY[k];
    var cities = (cfg.stores && cfg.stores.length) ? cfg.stores.map(function (s) { return s.short || s.name; }) : c.cities;
    var sec = el('section', 'brv brv--band');
    sec.setAttribute('data-mode', 'band');
    sec.setAttribute('data-film-mp4', cfg.mp4 || cfg.src || ''); sec.setAttribute('data-film-webm', cfg.webm || '');
    sec.setAttribute('data-film-phone-mp4', cfg.phoneMp4 || ''); sec.setAttribute('data-film-phone-webm', cfg.phoneWebm || '');
    sec.innerHTML =
      '<div class="brv__stage">' +
        (cfg.poster ? '<img class="brv__poster" src="' + esc(cfg.poster) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<video class="brv__video" muted playsinline loop preload="none" disablepictureinpicture disableremoteplayback aria-label="' + esc(c.alt) + '"></video>' +
      '</div><div class="brv__shade"></div>' +
      '<div class="brv__text"><span class="brv__eyebrow">' + esc(c.eyebrow) + '</span><h2 class="brv__title">' + esc(c.title) + '</h2>' +
        '<a class="brv__btn" href="' + esc(c.href) + '">' + esc(c.cta) + '</a></div>' +
      '<p class="brv__cities">' + cities.map(esc).join(' · ') + '</p>';
    sec.setAttribute('data-built', '1');
    var after = (cfg.after && q(cfg.after)) || q('.brg') || q('.brc2') || q('.br-best') || null;
    if (after && after.parentNode) after.parentNode.insertBefore(sec, after.nextSibling);
    else (q('main') || d.body).appendChild(sec);
    return sec;
  }

  function init() {
    if (w.__brv && w.__brv.destroy) { try { w.__brv.destroy(); } catch (e) {} }
    var sec = q('section.brv');
    if (!sec && w.BRV) sec = build(w.BRV);
    if (!sec) return;
    var v = q('video', sec); if (!v) return;
    var stage = q('.brv__stage', sec) || sec;
    var A = function (n) { return sec.getAttribute('data-film-' + n) || ''; };
    var files = { mp4: A('mp4'), webm: A('webm'), phoneMp4: A('phone-mp4'), phoneWebm: A('phone-webm') };
    if (!files.mp4 && !files.webm && !v.getAttribute('src') && !q('source', v)) return;
    sec.classList.add('brv--on');

    var offs = [], timers = [];
    function on(t, ev, fn, o) { t.addEventListener(ev, fn, o); offs.push(function () { t.removeEventListener(ev, fn, o); }); }

    /* a film may only start by itself when it is muted and plays in the page: set it every way there is */
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.loop = true; v.controls = false; v.autoplay = false; v.removeAttribute('autoplay');
    try { v.disablePictureInPicture = true; v.disableRemotePlayback = true; } catch (e) {}

    /* ---- which file ---- */
    var chosen = '';
    function pick() {
      var r = sec.clientWidth / Math.max(1, sec.clientHeight);
      var phone = r <= PHONE_RATIO && (files.phoneMp4 || files.phoneWebm);
      var mp4 = phone ? files.phoneMp4 : files.mp4, webm = phone ? files.phoneWebm : files.webm;
      var h264 = !!(v.canPlayType && v.canPlayType('video/mp4; codecs="avc1.640028"'));
      var vp9 = !!(v.canPlayType && v.canPlayType('video/webm; codecs="vp9"'));
      if (mp4 && (h264 || !webm || !vp9)) return mp4;
      return webm || mp4;
    }
    function ensureSrc() {
      if (chosen || v.getAttribute('src') || q('source', v)) { if (!chosen) chosen = v.currentSrc || v.getAttribute('src') || 'markup'; return; }
      chosen = pick(); if (!chosen) return;
      v.preload = 'auto'; v.src = chosen;
      try { v.load(); } catch (e) {}
    }
    function rate() { if (EXTRA_SPEED !== 1) { try { v.defaultPlaybackRate = EXTRA_SPEED; v.playbackRate = EXTRA_SPEED; } catch (e) {} } }
    on(v, 'loadedmetadata', rate);

    /* ---- show the film only once a real frame is on screen (until then the poster shows) ---- */
    var shown = false;
    function reveal() { if (shown) return; shown = true; sec.classList.add('is-playing'); }
    function waitFrame() {
      if (shown) return;
      if (v.requestVideoFrameCallback) { try { v.requestVideoFrameCallback(function () { reveal(); }); return; } catch (e) {} }
      var t = setInterval(function () { if (v.currentTime > 0 && !v.paused) { clearInterval(t); reveal(); } }, 50); timers.push(function () { clearInterval(t); });
    }
    on(v, 'playing', waitFrame);

    /* the film's last card: let it speak on its own where its bottom line would be under our words */
    function lastLineShows() {
      var r = sec.clientWidth / Math.max(1, sec.clientHeight), fr = (v.videoWidth && v.videoHeight) ? v.videoWidth / v.videoHeight : 4 / 3;
      var f = Math.min(1, fr / r);                       /* share of the film's height on screen */
      var top = (1 - f) * (sec.clientWidth >= 768 ? 0.25 : 0.5);   /* matches the CSS: 25 % on a computer, middle on a phone */
      return top + f > 0.86;                             /* the line sits at 86-89 % of the film's height */
    }
    /* computers: the 4:3 film is shown as a wide slice, so its last line would be cut off. During the end card the
       slice moves down (it moves while the screen is black, so nobody sees it move) and moves back as the film fades in again */
    function endcardCheck() {
      var inCard = END_CARD_AT > 0 && v.currentTime >= END_CARD_AT && v.currentTime < END_CARD_TO;
      var shows = inCard && lastLineShows();
      if (shows !== sec.classList.contains('is-endcard')) sec.classList.toggle('is-endcard', shows);
      var low = inCard && !shows;
      if (low !== sec.classList.contains('is-endcard-low')) sec.classList.toggle('is-endcard-low', low);
    }
    on(v, 'timeupdate', endcardCheck); on(v, 'seeked', endcardCheck);
    var ec = setInterval(function () { if (!v.paused) endcardCheck(); }, 100); timers.push(function () { clearInterval(ec); });

    /* ---- play / pause ---- */
    var started = false, visible = false, userStart = false, blockedArmed = false;
    function play() {
      if (reduce && !userStart) return;
      if (d.hidden) return;
      ensureSrc();
      if (!started) { started = true; try { if (v.currentTime > 0) v.currentTime = 0; } catch (e) {} }   /* first time: from the start */
      rate();
      var p;
      try { p = v.play(); } catch (e) { armRetry(); return; }
      if (p && p.then) p.then(function () {}, function (err) { if (!err || err.name !== 'AbortError') armRetry(); });
    }
    function pause() { try { if (!v.paused) v.pause(); } catch (e) {} }

    /* the phone refused (Low Power Mode): keep the poster, no button, try again on the next scroll or tap anywhere */
    function armRetry() {
      if (blockedArmed) return; blockedArmed = true; sec.classList.add('is-waiting');
      var evs = ['touchend', 'click', 'keydown', 'scroll', 'wheel'];
      function retry() {
        evs.forEach(function (e) { w.removeEventListener(e, retry, true); });
        blockedArmed = false; sec.classList.remove('is-waiting');
        if (visible) play();
      }
      evs.forEach(function (e) { w.addEventListener(e, retry, { capture: true, passive: true }); });
      offs.push(function () { evs.forEach(function (e) { w.removeEventListener(e, retry, true); }); });
    }

    /* starts at 35 % on screen; pauses once it has left the screen completely; carries on where it was when it comes back.
       (If the screen is shorter than the section, "35 %" becomes "most of what fits on screen".) */
    function need() { var h = sec.offsetHeight || 1; return Math.min(START_AT, 0.9 * (w.innerHeight || h) / h); }
    var io = null, io2 = null;
    if (w.IntersectionObserver) {
      var th = []; for (var i = 0; i <= 20; i++) th.push(i / 20);
      io = new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        if (!e.isIntersecting || e.intersectionRatio === 0) { visible = false; pause(); return; }
        if (e.intersectionRatio >= need() - 0.001) { visible = true; if (v.paused) play(); }
      }, { threshold: th });
      io.observe(sec); offs.push(function () { io.disconnect(); });
      /* fetch the film a little before the visitor gets there, so it starts at once */
      io2 = new IntersectionObserver(function (es) { if (es[es.length - 1].isIntersecting) { ensureSrc(); io2.disconnect(); } },
                                     { rootMargin: '0px 0px ' + Math.round(FETCH_AHEAD * 100) + '% 0px' });
      io2.observe(sec); offs.push(function () { io2.disconnect(); });
    } else { visible = true; play(); }
    on(d, 'visibilitychange', function () { if (d.hidden) pause(); else if (visible) play(); });
    /* if a browser does not loop by itself, start again from the beginning */
    on(v, 'ended', function () { try { v.currentTime = 0; } catch (e) {} if (visible) play(); });
    /* "reduce motion": a tap on the film starts it, a second tap stops it (no symbol either way) */
    if (reduce) on(stage, 'click', function () { if (v.paused) { userStart = true; play(); } else pause(); });

    w.__brv = {
      section: sec, video: v, play: play, pause: pause,
      seek: function (s) { try { v.currentTime = s; } catch (e) {} },
      state: function () {
        return { currentTime: Math.round(v.currentTime * 100) / 100, duration: Math.round((v.duration || 0) * 100) / 100, paused: v.paused,
                 readyState: v.readyState, muted: v.muted, loop: v.loop, rate: v.playbackRate, src: (chosen || '').split('/').pop().split('?')[0],
                 started: started, shown: shown, visible: visible, waiting: blockedArmed, endcard: sec.classList.contains('is-endcard'), videoWidth: v.videoWidth, videoHeight: v.videoHeight };
      },
      destroy: function () {
        offs.forEach(function (f) { try { f(); } catch (e) {} }); timers.forEach(function (f) { try { f(); } catch (e) {} });
        pause(); sec.classList.remove('brv--on', 'is-playing', 'is-waiting', 'is-endcard', 'is-endcard-low');
        if (sec.getAttribute('data-built') && sec.parentNode) sec.parentNode.removeChild(sec);
        w.__brv = null;
      }
    };
  }

  function boot() { try { init(); } catch (e) { /* never break the page */ } }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();